// extracted by mini-css-extract-plugin
export var chevronIcon = "_bp-2";
export var teamName = "_bp-1";
export var teamSwitcherButton = "_bp-0";